// 任务对象类型
export enum JobTargetStatus {
  // 全平台
  ALL,
  // 无限制
  NO_LIMIT,
  // 城市
  CITY,
  // 商圈
  CBD,
  // 饭圈
  GROUP,
  // 企业
  COMPANY,
  //  商户
  MERCHANT,
  // 用户
  USER,
}

// 任务类型
export enum JobTypeStatus {
  // 顺丰老带新
  SF,
  // 复购任务
  REPURCHASE,
  // 意见任务
  OPINION,
  // 企业老带新
  COMPANY,
  // 饭圈老带新
  GROUP,
  // 新客首单任务
  NEW_CUSTOMER,
  // 阶梯任务
  LADDER,
}

// 复购任务-任务方式
export enum JobMethodStatus {
  //累加
  ADD,
  //连续
  CONTINUITY,
}

// 任务奖励类型
export enum JobAwardTypeStatus {
  // 优惠券
  COUPON,
  // 返利金
  MONEY,
  // 无奖励
  NO_AWARD,
}

// 任务重复类型
export enum JobRepeatStatus {
  NO_REPEAT,
  REPEAT,
}

// 复购任务-是否限制金额
export enum ReJobLimitStatus {
  NO,
  YES,
}

// 阶梯任务-用户类型
export enum LadderJobUserTypeStatus {
  NEW,
  OLD,
}

export enum SubJobTypeStatus {
  NEW_CUSTOMER = 5,
  REPURCHASE = 1,
}

export interface IJobTypeDesc {
  // todo
  // award
  /**
   * 活动id
   */
  activityId: string;
  /**
   * 活动名称
   */
  activityName?: string;
  /**
   * 任务方式（0:累计方式 1:连续方式）
   */
  jobTypeWay: string;
  /**
   * 订单要求:订单数量
   */
  orderNum?: string;
  /**
   * 订单要求:连续天数
   */
  continuousDayNum?: string;
  /**
   * 订单要求:连续每天完成数
   */
  continuousOrderNum?: string;
  /**
   * 任务可重复（0:不重复 1:重复
   */
  isRepeated: string;
  /**
   * 可重复次数
   */
  repeatNum?: string;
  /**
   * 配送限制 0，全部 1,同城;2,自提
   */
  dispatchMethod: number;
  /**
   * 金额限制 0否 1是
   */
  amountLimited: number;
  /**
   * 订单金额限制值
   */
  orderLimitAmount?: number;
}

export interface IAwardItem {
  /**
   * 优惠券id
   */
  awardId: number;
  /**
   * 优惠券名称
   */
  awardName: string;
  /**
   * 优惠券数量
   */
  awardNum: number;
}

export interface IUserCouponItem {
  /**
   * 优惠券领取Id
   */
  userCouponId: number;
  /**
   * 优惠券状态1:已领取 2:已核销 3:已作废
   */
  couponStatus: number;
  /**
   * 领取人id
   */
  userId: number;
  /**
   * 领取人昵称
   */
  nickName: string;
  /**
   * 领取人手机号
   */
  phone: string;
  /**
   * 领取人企业
   */
  companyName: string;
  /**
   * 领取时间
   */
  receiveTime: string;
  /**
   * 核销时间
   */
  verificatTime: string;
  /**
   * 核销订单号
   */
  verificatOrderId: number;
}

export interface IDeliverCouponItem {
  /**
   * 优惠券id
   */
  couponsId: number;
  /**
   * 优惠券名称
   */
  couponsName: string;
  /**
   * 已领取数量
   */
  receiveNum: number;
  /**
   * 已核销数量
   */
  verificatNum: number;
  /**
   * 已作废数量
   */
  invalidNum: number;
}

export interface IJobTargetDescItem {
  /**
   * 企业id
   */
  companyId: number;
  /**
   * 企业name
   */
  companyName: string;
  /**
   * 用户名
   */
  userName: string;
  /**
   * 用户手机号
   */
  userPhone: number;
  /**
   * 用户id
   */
  userId: number;
  /**
   * 城市ode
   */
  cityCode: number;
  /**
   * 城市名
   */
  cityName: string;
  /**
   * 商圈name
   */
  businessDistrictName: string;
  /**
   * 商圈id
   */
  businessDistrictId: number;
  /**
   *
   * 饭圈id
   */
  groupId: number;
}

export interface IJobBlackTargetDesc {
  companyId?: number;
  userPhone?: number;
  companyName?: string;
  userName?: string;
  userId?: number;
  groupId?: number;
}
export interface IUserJobTarget {
  employee_phone?: string;
  company_name?: string;
  employee_name?: string;
  user_id?: number;
}

export interface ILadderJobItem {
  jobType: number;
  order: number;
  jobName: string;
  jobDesc: string;
  awardType: number;
  award:
    | {
        awardAmount?: number;
      }
    | IDeliverCouponItem[];
  jobTypeDesc: IJobTypeDesc;
  dispatchMethod: number[];
}
export interface IJobDetail {
  /**
   * 组件对应Id
   *
   */
  targetId: string;
  /**
   * 营销任务id
   */
  jobId?: number;
  /**
   * 任务名称
   */
  jobName?: string;
  /**
   * 任务说明
   */
  jobDesc?: string;
  /**
   * 开始时间
   */
  beginTime?: string;
  /**
   * 结束时间
   */
  endTime?: string;
  /**
   * 任务渠道
   */
  jobChannel?: string;
  /**
   * 黑名单
   */
  jobBlackTarget: number;
  /**
   * 黑名单对象详情
   */
  jobBlackTargetDesc?: IJobBlackTargetDesc[];
  /**
   * 任务对象
   */
  jobTarget?: number;
  /**
   * 任务对象详情
   */
  jobTargetDesc?: IJobTargetDescItem[];
  /**
   * 任务类型
   */
  jobType?: number;
  /**
   * 任务类型详情
   */
  jobTypeDesc?: IJobTypeDesc;
  /**
   * 优惠券信息
   */
  awardList?: IAwardItem[];
  isDeleted?: number;
  isStoped?: number;
  /**
   * 创建时间
   */
  createTime?: string;
  /**
   * 更新时间
   */
  updateTime?: string;
  /**
   * 优惠发放记录
   */
  userCouponList?: IUserCouponItem[];
  /**
   * 投送优惠券list
   */
  deliverCouponsList?: IDeliverCouponItem[];
  /**
   * 返利方式(0:优惠券,1:返利金,2:不返利)
   */
  awardType: number;
  /**
   * 奖励金额
   */
  awardAmount?: number;
  /**
   * 单日最多邀请人数
   */
  inviteMaxCount?: number;
  /**
   * 支付最低金额
   */
  minPayAmount?: number;
  /**
   * 用户类型 新/老
   */
  userType?: number;
  /**
   * 子任务
   */
  ladderChildJobs: ILadderJobItem[];
}
